import React from 'react';
import classnames from 'classnames';
import LazyImage from '../../@servierbar/lazyload/lazy-image/lazy-image.component';

const Avatar = ({ color, className, size, img, status, tag: Tag }) => {
  return (
    <Tag
      className={classnames('avatar', {
        [className]: className,
        [`bg-${color}`]: color,
        [`avatar-${size}`]: size,
      })}
    >
      <LazyImage
        image={img}
        src={img === null && '/assets/img/default_item_image_thumbnail.svg'}
        variant="thumbnail"
        className="thumbnail-h35 img-rounded"
        placeholderContainerClassNames="thumbnail-h35"
        placeholderClassNames="thumbnail-h35"
      />
      {status ? (
        <span
          className={classnames({
            [`avatar-status-${status}`]: status,
            [`avatar-status-${size}`]: size,
          })}
        ></span>
      ) : null}
    </Tag>
  );
};

export default Avatar;
